import { icons } from "../assets/icons";
import {
  techStack,
  projects,
  blogPost,
  certifications,
  socialLinks,
} from "../data/data";
import { Link } from "react-router-dom";

const Content = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-[65%_35%] gap-2">
        <div className="border border-gray-600 p-4 rounded-lg bg-white dark:bg-[#111111]">
          <span className="flex gap-1 items-center font-bold text-lg">
            {icons.about} About
          </span>
          <div className="text-sm mt-2 space-y-2 leading-relaxed text-pretty">
            <p>
              I'm a full-stack developer who specializes in building fast,
              responsive, and SEO-optimized websites. I work with modern
              technologies like{" "}
              <span class="text-blue-500 font-semibold">Next.js</span>,{" "}
              <span class="text-cyan-500 font-semibold">React</span>, and{" "}
              <span class="text-yellow-500 font-semibold">JavaScript</span> on
              the frontend, and{" "}
              <span class="text-green-500 font-semibold">Node.js</span> with{" "}
              <span class="text-red-500 font-semibold">Express</span> on the
              backend. My focus is on creating scalable and maintainable web
              applications that offer great user experiences.
            </p>

            <p>
              My passion for technology started in grade school when my parents
              introduced me to computers. Since then, I've been constantly
              exploring and building things on the web. I love solving problems,
              learning new tools, and turning ideas into functional
              applications.
            </p>
            <p>
              Outside of coding, I enjoy trying new things whether it's learning
              a new tech stack, working on creative side projects, or picking up
              new hobbies. I also enjoy movies, gaming, traveling. I also
              occasionally do livestreams on{" "}
              <a
                href="https://www.twitch.tv/knotz2k3"
                target="_blank"
                rel="noreferrer"
                className="text-violet-500 font-semibold hover:text-violet-700 hover:underline transition-all duration-300"
              >
                Twitch
              </a>
              .
            </p>
          </div>
        </div>

        <div className="border border-gray-600 p-3 rounded-lg dark:bg-[#111111] md:row-span-2">
          <div className="flex justify-between items-center">
            <span className="flex gap-1 items-center font-bold text-lg">
              {icons.certificate} Certifications
            </span>
            <Link
              to="/certifications"
              className="flex items-center text-xs cursor-pointer hover:underline transition-all duration-500 ease-in-out group"
            >
              View All
              <span className="transform transition-transform duration-500 ease-in-out group-hover:translate-x-1">
                {icons.arrowRight}
              </span>
            </Link>
          </div>
          <div className="flex flex-col gap-3 mt-2">
            {certifications.slice(0, 9).map((certificate) => (
              <a
                href={certificate.url}
                target="_blank"
                rel="noreferrer"
                key={certificate.name}
                className="border border-gray-600 dark:bg-black bg-[#f3f4f6] p-3 rounded-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-900 transition-all duration-300"
              >
                <h1 className="text-xs font-bold">{certificate.name}</h1>
                <p className="text-[11px]">{certificate.provider}</p>
              </a>
            ))}
          </div>
        </div>

        <div className="border border-gray-600 p-4 rounded-lg font-semibold bg-white dark:bg-[#111111]">
          <div className="flex justify-between items-center">
            <span className="flex gap-1 items-center font-bold text-lg">
              {icons.projects} Projects
            </span>
            <Link
              to="/projects"
              className="flex items-center text-xs cursor-pointer hover:underline transition-all duration-500 ease-in-out group"
            >
              View All
              <span className="transform transition-transform duration-500 ease-in-out group-hover:translate-x-1">
                {icons.arrowRight}
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
            {projects.slice(0, 4).map((project) => (
              <a
                key={project.name}
                className="font-normal border border-gray-600 px-3 py-6 rounded-lg transform transition-transform hover:-translate-y-0.5 duration-300 flex flex-col"
                href={project.url}
                target="_blank"
                rel="noreferrer"
              >
                <h1 className="font-bold text-sm">{project.name}</h1>
                <p className="text-xs my-2">{project.description}</p>
                <p className="text-xs bg-[#f3f4f6] dark:bg-black px-2 py-1 rounded-lg font-mono md:flex-wrap md:break-words">
                  {project.link}
                </p>
              </a>
            ))}
          </div>
        </div>

        <div className="border border-gray-600 p-4 rounded-lg col-span-1 md:col-span-2 bg-white dark:bg-[#111111]">
          <span className="flex gap-1 items-center font-bold text-lg">
            {icons.techStack} Tech Stack
          </span>
          <div className="flex mt-2 gap-1 flex-wrap">
            {techStack.map((stack) => (
              <span
                key={stack}
                className="text-xs border border-gray-600 py-1 px-2 rounded-lg"
              >
                {stack}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[35%_65%] gap-2 md:col-span-2 mt-2">
        <div className="border border-gray-600 p-3 rounded-lg dark:bg-[#111111]">
          <span className="flex gap-1 items-center font-bold text-lg">
            {icons.mail} Connect
          </span>
          <div className="mt-2">
            <p className="text-xs">Email</p>
            <div className="text-xs bg-[#f3f4f6] dark:bg-black mt-2 px-2 py-1 rounded-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-900 transition-all duration-300">
              <a
                className="font-semibold text-xs"
                href="mailto:aelnickclores@gmail.com"
              >
                aelnickclores@gmail.com
              </a>
            </div>
            <div className="my-2 bg-[#f3f4f6] dark:bg-black p-2 rounded-lg">
              <p className="text-xs text-pretty leading-relaxed">
                I'm looking for connection in{" "}
                <span className="font-bold">Full Stack Web Development</span>{" "}
                and{" "}
                <span className="font-bold">Software Engineering Industry</span>
                .<br />
                <span className="mt-2 block">
                  {" "}
                  Feel free to talk with me about
                  <span className="font-bold"> Web Development</span>,{" "}
                  <span className="font-bold">Software Engineering</span> and{" "}
                  <span className="font-bold">Gaming topics</span>.
                </span>
              </p>
            </div>
            <div>
              <p className="text-xs">Social Links</p>
              <div className="flex justify-between gap-2 mt-2">
                {socialLinks.map((social) => (
                  <a
                    key={social.link}
                    href={social.link}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={social.ariaLabel}
                    className="dark:bg-black bg-[#f3f4f6] flex justify-center flex-grow text-center p-2 rounded-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-900 transition-all duration-300"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border border-gray-600 p-3 rounded-lg dark:bg-[#111111]">
          <div className="flex justify-between items-center">
            <span className="flex gap-1 items-center font-bold text-lg">
              {icons.book} Blog Posts
            </span>
            <a
              href="https://medium.com/@alnick"
              target="_blank"
              rel="noreferrer"
              className="flex items-center text-xs cursor-pointer hover:underline transition-all duration-500 ease-in-out group font-semibold"
            >
              View All
              <span className="transform transition-transform duration-500 ease-in-out group-hover:translate-x-1">
                {icons.arrowRight}
              </span>
            </a>
          </div>
          <div className="grid grid-cols-1 gap-2 mt-2">
            {blogPost.map((post, index) => (
              <a
                key={index}
                href={post.url}
                target="_blank"
                rel="noreferrer"
                className="border border-gray-600 dark:bg-black bg-[#f3f4f6] p-3 rounded-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-900 transition-all duration-300"
              >
                <h1 className="text-sm font-bold mb-1">{post.title}</h1>
                <p className="text-xs line-clamp-2">{post.content}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Content;
